// extracted by mini-css-extract-plugin
export default {"modalOverlay":"YoutubeModal_modalOverlay__hS8QC","modalContent":"YoutubeModal_modalContent__VwHWB","closeButton":"YoutubeModal_closeButton__c2kPs"};